import { i18nConfigure } from '@openx/utils/i18n/i18n';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { App } from './App';
import { initialize as initializeEnvConfigs } from './environmentConfigs';
import { initialize as initializeAnalyticsTools } from './modules/analytics/initialize';

i18nConfigure();
initializeEnvConfigs();
initializeAnalyticsTools();

globalThis.__OPENX_VITE_ENV__ = import.meta.env;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
